<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{$t('profile.profileparameter.values')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ProfileParameterSetValueForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ProfileParameterSetValueForm from '../../components/profileparametersetvalue/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'ProfileParameterSetValue';
const routeAfterDel = 'ProfileParameterSetUpdate';
const routeAfterDelId = 'profileParameterSet';
const routeAfterDelIdObject = true;
export default {
  name: 'ProfileParameterSetValueUpdate',
  servicePrefix,
  routeAfterDel,
  routeAfterDelId,
  routeAfterDelIdObject,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    ProfileParameterSetValueForm
  },

  computed: {
    ...mapFields('profileparametersetvalue', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('profileparametersetvalue', ['find'])

  },

  methods: {
    ...mapActions('profileparametersetvalue', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
